<template>
  <div class="notifi-not-connected-card">
    <div class="content-container">
      <img
        :style="{ marginBottom: '12px' }"
        src="@/notifi-vue-package/assets/icn-unlink.svg"
      />
      Connect your wallet to use notifications
    </div>
  </div>
</template>

<style lang="scss" scoped>
.notifi-not-connected-card {
  height: 500px;
  display: flex;
  flex-direction: column;
}

.content-container {
  flex-grow: 1;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}
</style>
